import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_SEVERITY } from '@ddt-web/config';
import * as get from 'lodash/get';

import { ErrorObject } from '../../models/error-object';
import { AbstractErrorHandlerService } from '../abstract-error-handler.service';
import { ErrorHelperService } from '../error-helper.service';
import { ErrorPopupService } from '../error-popup.service';

@Injectable()
export class PasCorrelationMatrixErrorHandlerService extends AbstractErrorHandlerService {
	private flagErrorConfigs = ['correlation-matrix'];

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(
			contentService,
			errorPopupService,
			tealiumAnalyticsService,
			errorHelperService
		);
	}

	public handleError(error): void {
		const configName = get(error, 'configName', '');
		if (error instanceof ErrorObject && this.flagErrorConfigs.includes(configName)) {
			// Setup scope variables
			const errorObject = error.responseJson;

			// Set error severity
			this.errorSeverity = ERROR_SEVERITY.ERROR;

			console.error('There was an error while retrieving data for config: ' + configName, errorObject);

			this.handleErrorTracking('unabletoprocessrequest', this.errorSeverity);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
